/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { AutocompleteChangeReason, Button, Chip } from "@mui/material";
import VehicleForm from "./VehicleForm";
import { VehicleModel } from "../../Utils/Models";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import StandardActionButtons from "../StandarsActionButtons";
import { updateVehicle } from "./VehicleUtils";
import { hexToColorName } from "../../Utils/Utils";

export const CRUDContext = createContext(new VehicleModel());

export default function VehiclesTable() {
  const [contextValue, setContextValue] = useState(new VehicleModel());
  const [open, setOpen] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();

  /**
   *
   */
  const vehiclesColumns = [
    {
      label: `${Vocabulary.brand}`,
      name: "brand",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.model}`,
      name: "model",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.chassis}`,
      name: "chassis",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.vehicleNumber}`,
      name: "vehicleNumber",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.workPoint}`,
      name: "workPointId",
      options: {
        sort: false,
        customBodyRender: (rowData: any) => {
          return <>{rowData?.name}</>;
        },
        exportValue: (rowData: any) => rowData?.name || "",
      },
    },
    {
      label: `${Vocabulary.color}`,
      name: "color",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRender: (rowData: string) => {
          return (
            <>
              <Chip
                key={rowData?.toString()}
                label={""}
                style={{
                  margin: 5,
                  background: rowData,
                }}
              />
            </>
          );
        },
        exportValue: (rowData: string) => hexToColorName(rowData),
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.vehicles}
          columns={vehiclesColumns}
          CRUDEndPoint={endpoints.vehicle.main}
          id={TablesIds.vehicle}
          handleModalForm={setOpen}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue(new VehicleModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue(new VehicleModel());
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.vehicleForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <VehicleForm
                setContextValue={(
                  e: any,
                  client: VehicleModel | null,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => ({})}
                onClose={() => {
                  setOpen(false);
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                  setContextValue(new VehicleModel());
                }}
                name="VehicleForm"
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
          showPrintButton
          showDownloadButton
          exportWithTimestamp
        />
        <GenericModal
          open={openStatusModal}
          onClose={() => {
            setOpenStatusModal(false);
          }}
          style={{ zIndex: 9999 }}
          title={Vocabulary.confirm}
          actions={
            <StandardActionButtons
              okAction={() => {
                const currentVehicle = contextValue;
                // Toggle the isActive property
                currentVehicle.isActive = !currentVehicle.isActive;
                // Update the vehicle
                updateVehicle(currentVehicle, null);
                setOpenStatusModal(false);
                setContextValue(new VehicleModel());
              }}
              cancelAction={() => setOpenStatusModal(false)}
              okText={Vocabulary.yes}
              cancelText={Vocabulary.no}
            />
          }
        >
          <div>
            {contextValue.isActive
              ? Vocabulary.confirmDeactivateVehicle
              : Vocabulary.confirmActivateVehicle}
          </div>
        </GenericModal>
      </CRUDContext.Provider>
    </div>
  );
}
